/**
 * useInvoiceCheckDetail — the Rechnungskontrolle peek facts (Story UI-U4).
 *
 * live mode → GET /invoices/:id/check-detail via the typed client.
 * mock mode → resolves CHECK_DETAIL_MOCK[id] (null when absent — the peek then
 *             degrades gracefully to the list-row facts).
 *
 * [Source: apps/web/src/features/invoices/hooks/useInvoiceRows.ts] (live/mock split)
 */

import { useQuery } from '@tanstack/react-query';
import type { InvoiceCheckDetailDto } from '@brokly/shared';
import { qk } from '../../../lib/query-keys';
import { isLiveData } from '../../../lib/data-mode';
import { fetchCheckDetail } from '../api/invoices-api';
import { CHECK_DETAIL_MOCK } from '../mock';

export function useInvoiceCheckDetail(id: string | null) {
  const live = isLiveData();
  return useQuery<InvoiceCheckDetailDto | null>({
    queryKey: qk.invoiceCheckDetail(id ?? 'none'),
    queryFn: () =>
      live
        ? fetchCheckDetail(id as string)
        : Promise.resolve(CHECK_DETAIL_MOCK[id as string] ?? null),
    enabled: id !== null,
  });
}
